import { render } from "./IdeaTypeSelect.vue?vue&type=template&id=b50e2e96&scoped=true"
import script from "./IdeaTypeSelect.vue?vue&type=script&lang=js"
export * from "./IdeaTypeSelect.vue?vue&type=script&lang=js"

import "./IdeaTypeSelect.vue?vue&type=style&index=0&id=b50e2e96&lang=scss&scoped=true"

import exportComponent from "/Users/simonkravec/weby/zmen-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b50e2e96"]])

export default __exports__